import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Masonry from 'react-masonry-component';
import { connect } from 'react-redux';
import Image from './../dom-elements/Image';
import MasonryDesk from './MasonryDesk';
import SingleLineCaption from '../dom-elements/SingleLineCaption';
import { returnCategories } from './../../scripts';
import { breakpoints } from './../../styles/theme.json';

const MasonryGrid = (props) => {
  const ImageGridMasonryMobile = props.GridItems.map((item, i) =>
    <li className={'mg-li'} key={'masonry-item-mobile' + item.image.id + i}>
      <div className={'masonry-grid-item ' + returnCategories(item.nav_categories)}>
        <Link to={'/' + item.link.postType + '/' + item.link.slug} className="grid-item-link">
          <div className={'photo-landing-image-wrapper'}>
            <Image source={item.image.small} />
          </div>
          <SingleLineCaption
            Headline={item.project_caption.headline}
            Description={item.project_caption.description}
            Stacked={false}
            Sep={true}
          />
        </Link>
      </div>
    </li>
  );
  return (
    <section id={'filter-grid'}>
      {(props.window_width >= breakpoints.desktop)
        ? <MasonryDesk GridItems={props.GridItems}/>
        : <ul className={'masonry-grid-wrapper masonry-grid-mobile'}>
            {ImageGridMasonryMobile}
          </ul>
      }
    </section>
  );
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(MasonryGrid);



// WEBPACK FOOTER //
// ./src/components/filter-pages/MasonryGrid.js